import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, Link, useParams } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { saveAs } from 'file-saver';


const ViewDailyOrderDetail = () => {
    const { id } = useParams();
    const [name, setName] = useState('');
    const [timeZone, setTimeZone] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [importHistory, setOrderHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);

    const navigate = useNavigate();    
    useEffect(() => {
        refreshToken();
        getUserAccess();
    }, []);

    useEffect(() => {
        if (access.length > 0 && token) {
            checkAccess();
        }
    }, [access, token]);

    useEffect(() => {
        getDailyOrderListHistory();
    }, [page, token, id]);

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    }

    const getDailyOrderListHistory = async () => {
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/view-daily-order-detail/${atob(id)}?page=${page}&limit=${20}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data);
        setPopupOpen(false);
        setOrderHistory(response.data.data);
        setTotalItem(response.data.totalItem);
    }
    

    const getExportResult = async (item, type)=>{
        setPopupOpen(true);
        
        
        const response = await axiosJWT.get(`${baseUrl}/daily-order-list-export-result/${atob(id)}?type=${type}&item=${item}`,{
            headers: {
                Authorization: `Bearer ${token}`
            },
            responseType: 'blob',
        });
    
        if(type == 2){
            const blob = new Blob([response.data], { type: 'application/zip' });
            saveAs(blob, `${atob(id)}.zip`);   
        }else{
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `${item}`);
        }
        setPopupOpen(false)
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            console.log(response.data.results);
            setAccess(response.data.results);
            // setIsLoading(false);

        } catch (error) {
            console.log(error);

        }
    }    

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);

            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setTimeZone(decoded.timezone)

        } catch (error) {

            if (error.response) {
                // setError("Unauthorized");
                navigate("/");
                window.location.reload();
            }
        }
    }

   
    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
    };
    const checkAccess = async () => {
        if (role > 2 || !hasPermission('dolaccess')) {
            navigate('/dashboard');
        }
    }

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    return (
        <div className="panelbox">
            <Navbar token={token} access={access} />
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                    <Loader />
                )}
                <div className="content-page">

                    <div className="row">
                        <div className="col-8">
                            <div className="left-title">
                                <h1>Daily Order Detail</h1>
                            </div>
                        </div>

                        <div className="col-4 top-right-buttons">
                            <div className="export-btn addnew-button"><Link to="/daily-order-list"><span>&larr;</span> Back</Link></div>
                            {importHistory.length > 0 && <div className='export-btn addnew-button'><a href="#" className='newrow' onClick={() => { getExportResult(null, 2)}} >Download Zip</a></div>}
                        </div>

                    </div>

                   
                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <div className=" setting-section haft-whitebox">                                
                                {importHistory.length > 0 && <table className="tablebox search-result-table">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Action</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {importHistory.map((importItem, index) => (
                                            <tr key={index}>
                                                <td>{importItem}</td>
                                                <td>
                                                   <button onClick={() => { getExportResult(importItem, 1)}}>  
                                                        <img src={`${process.env.PUBLIC_URL}/images/download.png`} alt="" />

                                                    </button>
                                                </td>
                                                
                                            </tr>))}
                                    </tbody>
                                </table>}
                                {importHistory.length == 0 && <div className="row error">   No files are available</div>}

                                {totalItem > 20 && (<Pagination
                                    activePage={page}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalItem}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange.bind(this)}
                                />)}

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    )
}

export default ViewDailyOrderDetail